<template>
    <div class="mobile:p-[5px] tablet:p-[10px] mobile:rounded-[12px] laptop:rounded-[20px] border-[1px] border-[#CCCCCC]"
        :class="config ? 'min-h-max' : 'min-h-screen'">
        <div v-if="config"
            class="mb-[15px] mobile:rounded-[10px] laptop:rounded-[20px] border-[1px] border-[#CCCCCC] bg-[#fff]">
            <!-- Dynamic Loop -->
            <div
                class="m-[10px] mobile:p-[10px] tablet:px-[10px] tablet:py-[20px] rounded-[10px] shadow-[0_0_8px_1px_#00000012] bg-[#2459A8]">
                <customCurrencyInput ref="refFrequency" v-model="config.frequency.dist_value" :label="config.frequency.title"
                    :description="config.frequency.description" type="number"
                    mainInputWrapper="w-full mobile:rounded-[5px] largeDesktop:rounded-[10px] tablet:w-[150px] laptop:!min-w-[300px] largeDesktop:!min-w-[400px]"
                    mainWrapperClass="flex mobile:flex-col-reverse tablet:flex-row tablet:items-center justify-between mobile:gap-[20px] laptop:gap-[30px]"
                    fieldType="number" maxLength="1" :minValue=0 :maxValue=5
                    labelRequiredColor="!text-{#FE5000}"
                    labelClass="!text-[16px] font-roboto !font-semibold text-[#F5B134]"
                    spanTextClass="text-[#fff] text-[14px] font-roboto" placeholder="Enter number of months" currency=""
                    customClass="!h-[35px] 2xl:!h-[37px] !text-[16px] pl-[10px] !text-[#333333] 
                              !border-[#EFEFEF] mobile:!rounded-[10px] laptop:!rounded-[20px] font-roboto w-full"
                    customErrorClass="!text-[12px] bottom-[-20px] !text-[#fff]"
                    :spanTextDescription="!!config.frequency.description" required :validation="{
                        pattern: /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                        message: 'Invalid percentage.'
                    }" />
            </div>
        </div>
        <div v-if="config" class="rounded-[10px] mobile:p-[10px] laptop:p-[20px] flex flex-col gap-[15px] bg-[#fff]">
            <div v-for="(item, index) in config.items" :key="index"
                class="mobile:p-[15px] laptop:p-[20px] rounded-[10px] shadow-[0_0_8px_1px_#00000012] bg-[#fff]">
                <customCurrencyInput :ref="'ref_description_' + item.id" v-model="item.value" :label="item.title"
                    :description="item.description" type="number"
                    mainInputWrapper="w-full mobile:rounded-[5px] largeDesktop:rounded-[10px] tablet:!w-[150px] laptop:!min-w-[285px] largeDesktop:!min-w-[385px]"
                    mainWrapperClass="flex mobile:flex-col-reverse tablet:flex-row tablet:items-center justify-between mobile:gap-[20px] laptop:gap-[30px]"
                    fieldType="float" maxLength="3" labelClass="!text-[16px] font-roboto !font-semibold text-[#2459A8]"
                    labelRequiredColor="!text-{#FE5000}"
                    spanTextClass="!text-[#333] text-[14px] font-roboto" :placeholder="'Level ' + item.level + ' Commission'"
                    currency="%" customClass="!h-[35px] 2xl:!h-[37px] !text-[16px] pl-[10px] !text-[#333333] 
                              !border-[#EFEFEF] !rounded-[20px] font-roboto w-full"
                    customErrorClass="!text-[12px] bottom-[-20px]" :spanTextDescription="!!item.description" required
                    :validation="{
                        pattern: /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                        message: 'Invalid percentage.'
                    }" />
            </div>
            <div
                class="flex items-center justify-center mobile:gap-[10px] tablet:gap-[20px] mobile:my-[20px] laptop:mt-[30px]">
                <button @click="cancelClicked()"
                    class="!outline-none min-w-[120px] px-[30px] py-[7px] text-[16px] font-roboto rounded-full CustomYellowBtn">Cancel</button>
                <button @click="submitClicked()"
                    class="!outline-none min-w-[120px] px-[30px] py-[7px] text-[16px] font-roboto rounded-full CustomBlueBtn">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
import customCurrencyInput from '../../components/partialComponent/customCurrencyInput.vue';
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    components: {
        customCurrencyInput,
    },

    data() {
        return {
            config: null
        }
    },

    computed: {
        ...mapGetters([
            "levelsConfig", "updateAffiliateComissionResponse"
        ]),

    },

    watch: {
        levelsConfig: function (data) {
            this.config = JSON.parse(JSON.stringify(this.levelsConfig))
        },

        updateAffiliateComissionResponse: function (data) {
            toast.success(this.updateAffiliateComissionResponse.message);
        },
    },

    mounted() {
        document.title = "fyxify :: Commission Rule";
        this.getConfig()
    },

    methods: {
        ...mapActions([
            "getLevelConfig", "updateAffiliateComission"
        ]),

        isValid() {
            var status = true
            let firstInvalidField = null;
            for (let index = 0; index < this.config.items.length; index++) {
                const element = this.config.items[index];
                const inputComponent = this.$refs['ref_description_' + element.id][0];
                if (inputComponent && typeof inputComponent.validateField === "function") {
                    inputComponent.validateField(); // Call validation
                    if (inputComponent.hasError && !firstInvalidField) {
                        firstInvalidField = inputComponent; // Store first invalid field
                    }
                    if (inputComponent.hasError) {
                        status = false;
                    }
                }
            }

            const inputComponent = this.$refs['refFrequency'];
            if (inputComponent && typeof inputComponent.validateField === "function") {
                inputComponent.validateField(); // Call validation
                if (inputComponent.hasError && !firstInvalidField) {
                    firstInvalidField = inputComponent; // Store first invalid field
                }
                if (inputComponent.hasError) {
                    status = false;
                }
            }

            if (firstInvalidField) {
                this.$nextTick(() => {
                    firstInvalidField.$el.scrollIntoView({ behavior: "smooth", block: "center" });
                    firstInvalidField.$el.querySelector("input").focus();
                });
            }
            return status
        },

        sumLevels() {
            return this.config.items.reduce((total, item) => {
                const num = parseFloat(item.value);
                console.log(item.title, num);

                return total + (isNaN(num) ? 0 : num);
            }, 0);
        },

        submitClicked() {
            if (this.isValid()) {
                if (this.sumLevels() == 100) {
                    this.$dialog.show({
                        title: "Alert",
                        text: "Are you sure you want to submit?",
                        // image: "pop-req-img.png",
                        // we are passing callback method for our confirm button
                        onConfirm: () => {
                            this.updateAffiliateComission(this.config);
                        },
                    });
                } else {
                    toast.error("Level totals must equal 100%; values above or below are not allowed.");
                }
            }
        },

        cancelClicked() {
            this.$router.go(-1);
        },

        getConfig() {
            this.getLevelConfig({});
        }

    }
}
</script>
